import { useState } from 'react'
import { useAuth } from '../auth/useAuth'
import { tieneRol } from '../auth/roles'
import { useEquipo } from './EquipoContext'
import { PlantillaTab } from './PlantillaTab'
import { ReadOnlyBanner } from './ReadOnlyBanner'
import { t } from './i18n'
import { categoriaLabel } from '../panel/i18n'
import { useLang } from '../i18n/LangProvider'
import { PageTopbar } from '../styles/PageTopbar'
import styles from './EquipoDetailPage.module.css'
import { AsistenciaTab } from '../asistencia/AsistenciaTab'
import { AsistenciaF11Tab } from '../asistencia/f11/AsistenciaF11Tab'
import { t as tAsistencia } from '../asistencia/i18n'
import { MinutajeTab } from '../minutaje/MinutajeTab'
import { t as tMinutaje } from '../minutaje/i18n'

const CATEGORIAS_CON_ASISTENCIA = ['eskola', 'f7', 'f11']
const CATEGORIAS_CON_MINUTAJE = ['f7', 'f11']

export function EquipoDetailPage() {
  const equipo = useEquipo()
  const lang = useLang()
  const { user } = useAuth()
  // Issue #65, 2026-10-09: "solo el administrador puede hacer esto" (borrar la sesión de un
  // jugador en Eskola/F7).
  const esAdmin = tieneRol(user, 'admin')
  const tieneAsistencia = CATEGORIAS_CON_ASISTENCIA.includes(equipo.categoria)
  const tieneMinutaje = CATEGORIAS_CON_MINUTAJE.includes(equipo.categoria)
  const esF11 = equipo.categoria === 'f11'
  const soloLectura = equipo.temporada.estado === 'cerrada'
  const [tab, setTab] = useState<'plantilla' | 'asistencia' | 'minutaje'>('plantilla')

  return (
    <div>
      <PageTopbar />
      {soloLectura && <ReadOnlyBanner />}
      <header className={styles.header}>
        {equipo.icono && <span aria-hidden>{equipo.icono}</span>}
        <h2>{equipo.nombre}</h2>
        <span className={styles.categoria}>{categoriaLabel(equipo.categoria, lang)}</span>
        {equipo.color && (
          <span
            aria-hidden
            style={{
              display: 'inline-block',
              width: 10,
              height: 10,
              borderRadius: '50%',
              backgroundColor: equipo.color,
            }}
          />
        )}
      </header>

      <nav className="tabs">
        <button onClick={() => setTab('plantilla')} disabled={tab === 'plantilla'}>
          {t('plantilla', lang)}
        </button>
        {tieneAsistencia && (
          <button onClick={() => setTab('asistencia')} disabled={tab === 'asistencia'}>
            {tAsistencia('asistencia', lang)}
          </button>
        )}
        {tieneMinutaje && (
          <button onClick={() => setTab('minutaje')} disabled={tab === 'minutaje'}>
            {tMinutaje('minutaje', lang)}
          </button>
        )}
      </nav>

      {tab === 'plantilla' && <PlantillaTab />}
      {tab === 'asistencia' && tieneAsistencia && esF11 && (
        <AsistenciaF11Tab equipoId={equipo.id} readOnly={soloLectura} />
      )}
      {tab === 'asistencia' && tieneAsistencia && !esF11 && (
        <AsistenciaTab
          equipoId={equipo.id}
          categoria={equipo.categoria === 'eskola' ? 'eskola' : 'f7'}
          readOnly={soloLectura}
          esAdmin={esAdmin}
        />
      )}
      {tab === 'minutaje' && tieneMinutaje && <MinutajeTab equipo={equipo} readOnly={soloLectura} />}
    </div>
  )
}
